<template>
  <riseup-header />
  <div class="remove-participant padding-ml">
    <div>
      <img
        class="image-container"
        :src="diamondImage"
      >
      <div class="ri-bold-title padding-top-l">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import { useChallengeStore } from '../../stores/challenge';
import diamondImage from '../../assets/diamond.svg';

const route = useRoute();
const challengeStore = useChallengeStore();
const { participantId } = storeToRefs(challengeStore);
const challengeId = computed(() => route.params.challengeId as string);
await challengeStore.init(challengeId.value);
if (participantId?.value) {
  await challengeStore.removeParticipantFromChallenge();
}

const title = computed(() => (participantId?.value ? 'הוסרת מהאתגר בהצלחה' : 'כבר הוסרת מהאתגר הזה'));

</script>

<style lang="scss" scoped>
@import "base-ui-vue3/src/scss/riseup-colors";

.remove-participant {
  text-align: center;
  .emoji {
    margin-top: 120px;
  }
  .image-container {
    width: 60px;
    height: 60px;
    margin-top: 120px;
  }
}
</style>
